import classes from './ArticleDate.module.css'

const ArticleDate = ({ date }) => {
  return <span className={`${classes['article-date']}`}>{date}</span>
}

export default ArticleDate
